import "./styles.css";
import "./styles/globals.css";
import RouterBuilder from "./App.router";
import LoginSignUpPage from "./layouts/LoginPage";
import { whoAmIResponse } from "@models/project";
import {useAuthInfo, withAuthInfo} from "@propelauth/react";
import {useState, useMemo, useEffect} from "react";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { whoAmI } from "./api/whoIAm_api";
import BaseLoadingSpinner from "./components/ui/baseLoadingSpinner";
import {QlinkPageWithEmail} from "./components/qlink/quickLinkPageWithEmail";
import {BulkInvitePage} from "./components/bulkInvite/BulkInvitePage";
// import {QlinkPageWithEmail} from "@/src/components/qlink/quickLinkPageWithEmail";


function App () {
    const {isLoggedIn, accessToken} = useAuthInfo();
    const [response, setResponse] = useState<whoAmIResponse | null>(null);

    /**
     * In theory, this should only run once, when the user logs in.
     * baiscally I want to do nothing if the token changes, but isLoggedin is still true.
     *
     * This will work as long as downstream, I am always pulling the token from the auth context.
     *
     * so we useMemo on the isLoggedIn
     *
     * */
    useEffect(() => {
            if (accessToken) {
                whoAmI(accessToken)
                    .then((data) => {
                        setResponse(data);
                        console.log('who am i', data)
                    }).catch((err) => {
                        //console.log('login error', err)
                });
            }
        }, [isLoggedIn]
    )

    if (isLoggedIn) {
        if (!response) {
            return <BaseLoadingSpinner/>
        } else {
            const routes = RouterBuilder(response);
            return <RouterProvider router={createBrowserRouter(routes)} />;
        }
    } else {
        //console.log('not logged in')
        return <RouterProvider router={createBrowserRouter([
        {
            path:'/*',
            element: <LoginSignUpPage />,
        },
            {
                path: "/qlink/:quid",
                element: <QlinkPageWithEmail/>
             },
            {
                path: "/invite/:token",
                element: <BulkInvitePage/>
             },
    ])} />;
    }
};

export default App;
